import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* ---------- LEFT : ABOUT US ---------- */}
        <div className="footer-about">
          <h3>The Blessing Interiors</h3>
          <p>
            The Blessing Interiors is a premium interior decor brand specializing
            in curtains, blinds, wallpapers, sofa fabrics, and Netlon installation.
            We transform homes and offices into elegant, comfortable spaces with
            quality materials and professional service.
          </p>
        </div>

        {/* ---------- CENTER : QUICK LINKS ---------- */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/works">Our Works</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* ---------- RIGHT : GOOGLE MAP ---------- */}
        <div className="footer-map">
          <h3>Our Location</h3>
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15665.390179305348!2d77.01641173665934!3d11.012529605932666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8573e66210ead%3A0x3409c6074c861b78!2sThe%20blessing%20interiors!5e0!3m2!1sen!2sus!4v1765959431294!5m2!1sen!2sus"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>

      </div>

      {/* ---------- COPYRIGHT ---------- */}
      <div className="footer-bottom">
        <p className="designed-by">{new Date().getFullYear()} Designed and Developed by <a href="https://jeginatechnologies.in" target="_blank" rel="noopener noreferrer">Jegina Technologies</a></p>
        <p className="copyright">© The Blessing Interiors. All Rights Reserved.</p>
      </div>

    </footer>
  );
}
